"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var SiteNavigationElementSchema = function SiteNavigationElementSchema(_ref) {
  var navigationElementId = _ref.navigationElementId,
      siteUrl = _ref.siteUrl,
      pages = _ref.pages;
  var navigationData = {
    '@context': 'http://schema.org',
    '@graph': pages.map(function (_ref2) {
      var slug = _ref2.slug,
          title = _ref2.title;
      return {
        '@context': 'https://schema.org',
        '@type': 'SiteNavigationElement',
        '@id': navigationElementId,
        name: title,
        url: "".concat(siteUrl).concat(slug)
      };
    })
  };
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(navigationData)));
};

var _default = SiteNavigationElementSchema;
exports["default"] = _default;
SiteNavigationElementSchema.propTypes = {
  navigationElementId: _propTypes["default"].string,
  siteUrl: _propTypes["default"].string.isRequired,
  pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    slug: _propTypes["default"].string,
    title: _propTypes["default"].string
  })).isRequired
};
SiteNavigationElementSchema.defaultProps = {
  navigationElementId: '#nav'
};